import {AbstractControl, FormGroup, ValidationErrors, ValidatorFn} from '@angular/forms';
import {
  IDocumentInfoFormGroup
} from '../../services/forms/new-case-filing-form/new-case-filing-form.service';
import {DeterminationCategoryIdEnum} from '../../../constants';
import {ICaseDocketEntryFormGroup} from '../../services/forms/case-form/case-form.service';
import {
  IDeterminationFormGroup
} from '../../services/forms/existing-case-filing-form/existing-case-filing-form.service';

/**
 * Validator for ecf determination award amount.
 */
export function ecfDeterminationAwardAmountValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const documentFG = control as FormGroup<IDocumentInfoFormGroup>;
    const determinationFG = documentFG?.controls.mainDocument?.controls.determination;
    if (!determinationFG || determinationFG.controls.category.value !== DeterminationCategoryIdEnum.Award) {
      return null;
    }
    return compareSums(determinationFG) ? null : { awardAmountNotEqual: true };
  };
}

/**
 * Validator for docket entry determination award amount.
 */
export function docketEntryDeterminationAwardAmountValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const entryFG = control as FormGroup<ICaseDocketEntryFormGroup>;
    const determinationFG = entryFG?.controls.mainDocument.controls.determination;

    if (!determinationFG || (determinationFG.controls && !determinationFG.controls.category)) {
      return null;
    } else if (!!determinationFG.controls && !!determinationFG.controls.category && determinationFG.controls.category.value !== DeterminationCategoryIdEnum.Award) {
      return null;
    }
    return compareSums(determinationFG) ? null : { awardAmountNotEqual: true };
  };
}

/**
 * Helper function to compare the total award amount to the sum of award types amounts.
 * @param determinationFG
 */
function compareSums(determinationFG: FormGroup<IDeterminationFormGroup>): boolean {
  const awardTypes = determinationFG.controls.awardTypes.controls;
  const totalAwardAmount = determinationFG.controls.totalAwardAmount.value;
  const sum = awardTypes.reduce((acc, ctrl) => acc + (ctrl.value.amount ?? 0), 0);
  // Amounts are currency values (2 decimal places). Floating point addition can
  // introduce tiny rounding errors (e.g. 18835.44 vs 18835.440000000002), so we
  // compare the values rounded to the nearest cent rather than with strict equality.
  return roundToCents(totalAwardAmount ?? 0) === roundToCents(sum);
}

/**
 * Rounds a currency value to the nearest cent, avoiding floating point comparison errors.
 * @param value
 */
function roundToCents(value: number): number {
  return Math.round(value * 100) / 100;
}
